import type { AsyncSequence } from "../types/AsyncSequence"

export async function* ArrayToIterable<T>(
  ...arrays: AsyncSequence<T>[]
): AsyncGenerator<T> {
  for (const array of arrays) {
    yield* array
  }
}
